var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#82AFFF"
    },
    width: 512,
    height: 512
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "94.316,0 0,0 0,19.977 94.316,81.77  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "0,68.299 0,94.316 39.71,94.316  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "0,161.684 0,187.701 39.71,161.684  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "256,19.977 256,0 161.684,0 161.684,81.77  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "256,187.701 256,161.684 216.29,161.684  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "161.684,174.23 161.684,256 256,256 256,236.023  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "256,94.316 256,68.299 216.29,94.316  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "0,236.023 0,256 94.316,256 94.316,174.23  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "256,236.023 256,216.059 172.232,161.684 196.98,161.684 256,199.995 256,187.701    216.29,161.684 256,161.684 256,148.21 148.211,148.21 148.211,256 161.684,256 161.684,174.23  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "0,148.21 0,161.684 39.71,161.684 0,187.701 0,206.602 69.197,161.684 93.945,161.684    0,222.666 0,236.023 94.316,174.23 94.316,256 107.789,256 107.789,148.21  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "107.789,0 94.316,0 94.316,81.77 0,19.977 0,41.839 80.842,94.316 56.094,94.316 0,57.904    0,68.299 39.71,94.316 0,94.316 0,107.79 107.789,107.79  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "256,107.79 256,94.316 216.29,94.316 256,68.299 256,49.157 186.432,94.316 161.684,94.316    256,33.093 256,19.977 161.684,81.77 161.684,0 148.211,0 148.211,107.79  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "256,148.21 256,107.79 148.211,107.79 148.211,0 107.789,0 107.789,107.79 0,107.79    0,148.21 107.789,148.21 107.789,256 148.211,256 148.211,148.21  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "69.197,161.684 0,206.602 0,222.666 93.945,161.684  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "172.232,161.684 256,216.059 256,199.995 196.98,161.684  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "80.842,94.316 0,41.839 0,57.904 56.094,94.316  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "186.432,94.316 256,49.157 256,33.093 161.684,94.316  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M203.959,415.958l-4.726,14.17l-14.936,0.116c-1.432,0.011-2.026,1.839-0.874,2.69l12.016,8.873   l-4.505,14.241c-0.432,1.366,1.123,2.495,2.288,1.662l12.152-8.686l12.152,8.686c1.165,0.833,2.72-0.297,2.288-1.662l-4.505-14.241   l12.016-8.873c1.152-0.851,0.558-2.679-0.874-2.69l-14.936-0.116l-4.726-14.17C206.334,414.6,204.412,414.6,203.959,415.958z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M434.028,305.614l-4.726,14.17l-14.936,0.116c-1.432,0.011-2.026,1.839-0.874,2.69l12.016,8.873   l-4.505,14.241c-0.432,1.366,1.123,2.495,2.288,1.662l12.152-8.686l12.152,8.686c1.165,0.833,2.72-0.297,2.288-1.662l-4.505-14.241   l12.016-8.873c1.152-0.851,0.558-2.679-0.874-2.69l-14.936-0.116l-4.726-14.17C436.403,304.255,434.481,304.255,434.028,305.614z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M434.028,186.441l-4.726,14.17l-14.936,0.116c-1.432,0.011-2.026,1.839-0.874,2.69l12.016,8.873   l-4.505,14.241c-0.432,1.366,1.123,2.495,2.288,1.662l12.152-8.686l12.152,8.686c1.165,0.833,2.72-0.297,2.288-1.662l-4.505-14.241   l12.016-8.873c1.152-0.851,0.558-2.679-0.874-2.69l-14.936-0.116l-4.726-14.17C436.403,185.082,434.481,185.082,434.028,186.441z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M263.104,341.412l4.665,14.19l-11.915,9.008c-1.143,0.864-0.528,2.685,0.904,2.68l14.937-0.052   l4.885,14.115c0.468,1.354,2.39,1.332,2.828-0.032l4.566-14.222l14.934-0.284c1.432-0.027,2.005-1.862,0.844-2.7l-12.115-8.737   l4.345-14.291c0.417-1.37-1.151-2.483-2.307-1.637l-12.053,8.822l-12.249-8.548C264.199,338.904,262.657,340.051,263.104,341.412z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M262.001,402.653l4.665,14.189l-11.915,9.008c-1.143,0.864-0.528,2.685,0.904,2.68l14.937-0.052   l4.885,14.115c0.468,1.354,2.39,1.332,2.828-0.032l4.566-14.222l14.934-0.284c1.432-0.027,2.005-1.862,0.844-2.7l-12.115-8.737   l4.345-14.291c0.417-1.37-1.151-2.483-2.307-1.637l-12.053,8.822l-12.249-8.548C263.095,400.145,261.553,401.293,262.001,402.653z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M326.552,387.205l4.665,14.189l-11.915,9.008c-1.143,0.864-0.528,2.685,0.904,2.68l14.937-0.052   l4.885,14.115c0.468,1.354,2.39,1.332,2.828-0.032l4.566-14.222l14.934-0.284c1.432-0.027,2.005-1.862,0.844-2.7l-12.115-8.737   l4.345-14.291c0.417-1.37-1.151-2.483-2.307-1.637l-12.053,8.822l-12.249-8.548C327.647,384.697,326.105,385.844,326.552,387.205z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M325.449,253.688l4.665,14.189l-11.915,9.008c-1.143,0.864-0.528,2.685,0.904,2.68l14.937-0.052   l4.885,14.115c0.468,1.354,2.39,1.332,2.828-0.032l4.566-14.222l14.934-0.284c1.432-0.027,2.005-1.862,0.844-2.7l-12.115-8.737   l4.345-14.291c0.417-1.37-1.151-2.483-2.307-1.637l-12.053,8.822L327.718,252C326.544,251.18,325.001,252.327,325.449,253.688z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M380.07,235.481l4.665,14.189l-11.915,9.008c-1.143,0.864-0.528,2.685,0.904,2.68l14.937-0.052   l4.885,14.115c0.468,1.354,2.39,1.332,2.828-0.032l4.566-14.222l14.934-0.284c1.432-0.027,2.005-1.862,0.844-2.7l-12.115-8.737   l4.345-14.291c0.417-1.37-1.151-2.483-2.307-1.637l-12.053,8.822l-12.249-8.548C381.164,232.973,379.622,234.12,380.07,235.481z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTv);
export default __webpack_public_path__ + "static/media/TV.3b9e4fbae202e3d586e95292c3dbc5af.svg";
export { ForwardRef as ReactComponent };